import { connect } from 'react-redux';
import { PowerSupply as Component } from './PowerSupply';
import {
  pushInteractions,
  setPowerSupplyAnodeConnected,
  setPowerSupplyCathodeConnected,
  setModal,
  showModal,
  createPowerSupply,
  hideAllControls,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if (state.notebook.protocolSection.scene.apparatus.hasOwnProperty("flask") &&
    state.notebook.protocolSection.scene.apparatus.flask.some(
      flask => flask.id === ownProps.id
    )
  ) {
    return {
      id: ownProps.id,
      anodeConnected: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].anodeConnected,
      cathodeConnected: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].cathodeConnected,
      active: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].active,
      voltage: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].voltage,
      current: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].current,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.flask[ownProps.id - 1].controlsVisible,
      interactionProps: {
        gelBoxes: state.notebook.protocolSection.scene.apparatus.gelBoxes,
      },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {

    setPowerSupplyAnodeConnected: (data) => {
      dispatch(setPowerSupplyAnodeConnected(data))
    },
    setPowerSupplyCathodeConnected: (data) => {
      dispatch(    setPowerSupplyCathodeConnected(data))
    },
    setModal: (data) => {
      dispatch(    setModal(data))
    },
    showModal: (data) => {
      dispatch(    showModal(data))
    },
    createPowerSupply: (data) => {
      dispatch(    createPowerSupply(data))
    },

    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },

    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },

  };
}

export const PowerSupply = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
